import _ from 'lodash';

class AudioObject {
  constructor(url, parent, context, destination, loop = true) {
    this.url = url;

    let domObject = this.domObject = new Audio();
    domObject.src = url;
    domObject.loop = loop;
    domObject.preload = 'auto';

    this.playablePromise = new Promise((resolve, reject) => {
      domObject.onloadedmetadata = resolve;
      domObject.onerror = reject;
    }).then((e) => {
      let now = Math.floor((new Date).getTime() / 1000);
      domObject.currentTime = now % Math.floor(e.target.duration);

      return new Promise((resolve) => {
        domObject.oncanplaythrough = resolve;
      });
    });

    parent.appendChild(domObject);

    let source = this.source = context.createMediaElementSource(domObject);
    let gainNode = this.gainNode = context.createGain();

    source.connect(gainNode);
    gainNode.connect(destination);
  }

  play() {
    return this.playablePromise.then((e) => {
      return e.target.play();
    });
  }

  pause() {
    this.domObject.pause();
  }

  get gain() {
    return this.gainNode.gain.value;
  }

  set gain(gain) {
    this.gainNode.gain.value = gain;
  }

  rewind() {
    this.playablePromise.then(() => {
      this.domObject.currentTime = 0;
    });
  }

  seek(time) {
    this.playablePromise.then(() => {
      this.domObject.currentTime = time % Math.floor(this.domObject.duration);
    });
  }
}

class AudioManager {
  constructor() {
    this.context =
      window.AudioContext ? new AudioContext() : (
        window.webkitAudioContext ? new window.webkitAudioContext() : null
      );
    this.master = this.context.createGain();
    this.master.connect(this.context.destination);
    this.muted = false;
    this.container = document.createElement('div');
    this.container.setAttribute('style', 'display: none');
    this.audioObjects = [];
    this.removing = [];
    this.nextStepTimeout = null;
    document.body.appendChild(this.container);

    this.transitions = _.range(0, 4).map((i) => {
      const obj = new AudioObject(
        `/audio/transitions/${i + 1}.mp3`,
        this.container,
        this.context,
        this.master,
        false
      );
      obj.gain = 2.5;

      return obj;
    });

    // this.underlyingLoop = new AudioObject(
    //   '/audio/one long file on top of everything.mp3',
    //   this.container,
    //   this.context,
    //   this.master
    // );
    // this.underlyingLoop.play();
  }

  toggleMute() {
    this.muted = !this.muted;

    if (this.muted) {
      this.master.gain.value = 0;
    } else {
      this.master.gain.value = 1;
    }
  }

  addAudioFromURL(url) {
    return new AudioObject(url, this.container, this.context, this.master);
  }

  removeAudioObject(obj) {
    this.audioObjects = _.filter(this.audioObjects, (x) => x != obj);
    obj.pause();
    this.container.removeChild(obj.domObject);
  }

  removeAudioObjects(objs) {
    _.forEach(objs, this.removeAudioObject.bind(this));
  }

  transitionFromURL(url) {
    const totalTimeMs = 4000;
    const intervals = 40;

    if (this.nextStepTimeout) {
      clearTimeout(this.nextStepTimeout);
      this.nextStepTimeout = null;
    }

    this.removing = this.removing.concat(this.audioObjects);
    this.audioObjects = [];

    let audioObject = this.addAudioFromURL(url);
    audioObject.gain = 0.0;
    this.audioObjects.push(audioObject);

    let intervalLength = Math.floor(totalTimeMs / intervals);
    // let gainStep = 1.0 / intervals;
    let gainStep = 1 / ((intervals / totalTimeMs) * 1000);
    let interval = 0;

    const transition = _.sample(this.transitions);
    transition.rewind();

    // stage 0 = start transition - t0
    // stage 1 = fade out - t2
    // stage 2 = silence - t3
    // stage 3 = fade in - t4
    let stage = 0;

    const step = () => {
      const time = intervalLength * interval;
      if ((stage === 0 && time >= 2000) ||
          (stage === 1 && time >= 3000) ||
          (stage === 2 && time >= 4000)) {
        stage++;
      }

      if (stage === 0 && interval === 0) {
        transition.play();
      } else if (stage === 1) {
        _.forEach(this.removing, (x) => {
          x.gain = Math.max(x.gain - gainStep, 0);
        });
      } else if (stage === 2) {
        audioObject.gain = Math.min(audioObject.gain + gainStep, 1);
      }

      // _.forEach(this.removing, (x) => x.gain = Math.max(x.gain - gainStep, 0));
      // audioObject.gain = audioObject.gain + gainStep;

      interval++;

      if (interval < intervals) {
        this.nextStepTimeout = setTimeout(step, intervalLength);
      } else {
        this.removeAudioObjects(this.removing);
        this.removing = [];
        this.nextStepTimeout = null;
        audioObject.gain = 1.0;
      }
    };

    const clear = () => {
      this.removeAudioObjects(this.audioObjects);
      this.removeAudioObjects(this.removing);
      this.audioObjects = [];
      this.removing = [];
    };

    audioObject.play().then(step).catch(clear);
  }
}

export default AudioManager;



// WEBPACK FOOTER //
// ./src/utils/AudioManager.js